/* YUNAIKO — barre d'achat collante.
   Mode « pdp » : relaie le vrai bouton de la fiche produit (pas de second formulaire).
   Mode « add » : contient son propre formulaire d'ajout (accueil).
   Visible seulement après l'élément cible, masquée dès qu'un autre bouton d'achat est à l'écran
   et à l'approche du pied de page. */
if (!customElements.get('yk-sticky-atc')) {
  customElements.define(
    'yk-sticky-atc',
    class YkStickyAtc extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        this.mode = this.dataset.mode || 'pdp';
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-yk-sticky-btn]');
        this.priceEl = this.querySelector('[data-yk-sticky-price]');
        this.target = document.querySelector(this.dataset.target);
        if (!this.target) return;
        this.hidden = false;
        this.past = false;
        this.nearFooter = false;
        this.visibleBuyers = new Set();

        new IntersectionObserver(([e]) => {
          this.past = !e.isIntersecting && e.boundingClientRect.top < 0;
          this.update();
        }).observe(this.target);

        const footer = document.querySelector('.footer, footer, .yk-footer');
        if (footer) new IntersectionObserver(([e]) => { this.nearFooter = e.isIntersecting; this.update(); }).observe(footer);

        const buyers = [...document.querySelectorAll('[data-yk-sticky-hide]')];
        if (this.mode === 'pdp') {
          const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          if (main) buyers.push(main);
        }
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? this.visibleBuyers.add(e.target) : this.visibleBuyers.delete(e.target)));
          this.update();
        });
        buyers.forEach((b) => io.observe(b));

        if (this.mode === 'pdp') {
          this.button && this.button.addEventListener('click', () => this.relay());
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.sync(), 60));
          }
        }
      }

      disconnectedCallback() { this.unsubscribe && this.unsubscribe(); document.body.classList.remove('yk-sticky-on'); }

      update() {
        const show = this.past && !this.nearFooter && this.visibleBuyers.size === 0;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.toggleAttribute('inert', !show);
        document.body.classList.toggle('yk-sticky-on', show);
      }

      sync() {
        const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (main && this.button) this.button.disabled = main.hasAttribute('disabled');
        const box = document.querySelector(`#price-${this.sectionId} .price`);
        if (box && this.priceEl) {
          const sale = box.classList.contains('price--on-sale');
          const current = box.querySelector(sale ? '.price-item--sale' : '.price__regular .price-item--regular');
          const compare = sale ? box.querySelector('.price__sale s') : null;
          this.priceEl.innerHTML = `${compare ? `<s>${compare.textContent.trim()}</s> ` : ''}${current ? current.textContent.trim() : ''}`;
        }
      }

      relay() {
        const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (main && main.offsetParent !== null && !main.hasAttribute('disabled')) { main.click(); return; }
        const anchor = document.getElementById('acheter') || this.target;
        anchor.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
  );
}
